module.exports = __webpack_public_path__ + "img/12.49b0da05.jpg";